// extracted by mini-css-extract-plugin
export default {"socials":"socials--B0JYD","icon":"icon--glmEn","blink":"blink--A2a8o"};